/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DataPackageFileUploadRequest
 */
export interface DataPackageFileUploadRequest {
    /**
     * 
     * @type {string}
     * @memberof DataPackageFileUploadRequest
     */
    filename: string;
}

/**
 * Check if a given object implements the DataPackageFileUploadRequest interface.
 */
export function instanceOfDataPackageFileUploadRequest(value: object): value is DataPackageFileUploadRequest {
    if (!('filename' in value) || value['filename'] === undefined) return false;
    return true;
}

export function DataPackageFileUploadRequestFromJSON(json: any): DataPackageFileUploadRequest {
    return DataPackageFileUploadRequestFromJSONTyped(json, false);
}

export function DataPackageFileUploadRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): DataPackageFileUploadRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'filename': json['filename'],
    };
}

export function DataPackageFileUploadRequestToJSON(json: any): DataPackageFileUploadRequest {
    return DataPackageFileUploadRequestToJSONTyped(json, false);
}

export function DataPackageFileUploadRequestToJSONTyped(value?: DataPackageFileUploadRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'filename': value['filename'],
    };
}

